import { FC } from 'react';

export type StatusKey = 'Accounting Approved' | 'Accounting Invoiced' | 'Paid';

export interface StatusChips {
  'Accounting Approved': boolean;
  'Accounting Invoiced': boolean;
  Paid: boolean;
}

interface FilterRowProps {
  companySearch: string;
  jobTitleSearch: string;
  candidateSearch: string;
  statuses: StatusChips;
  onCompanySearch: (v: string) => void;
  onJobTitleSearch: (v: string) => void;
  onCandidateSearch: (v: string) => void;
  onToggleStatus: (key: StatusKey) => void;
}

// Labels match DtoForPlacement (constant.tsx) used on the Placement Management page
const CHIP_META: { key: StatusKey; label: string; cssClass: string }[] = [
  { key: 'Accounting Approved', label: 'Acctg_Apprvd',   cssClass: 'chip-approved' },
  { key: 'Accounting Invoiced', label: 'Acctg_Invoiced', cssClass: 'chip-invoiced' },
  { key: 'Paid',                label: 'Paid',           cssClass: 'chip-paid'     },
];

const FilterRow: FC<FilterRowProps> = ({
  companySearch,
  jobTitleSearch,
  candidateSearch,
  statuses,
  onCompanySearch,
  onJobTitleSearch,
  onCandidateSearch,
  onToggleStatus,
}) => {
  return (
    <div className="ia-filter-row">
      <div className="ia-filter-input">
        <label>Company</label>
        <input
          type="text"
          value={companySearch}
          placeholder="Search companies…"
          onChange={(e) => onCompanySearch(e.target.value)}
        />
      </div>

      <div className="ia-filter-input">
        <label>Candidate</label>
        <input
          type="text"
          value={candidateSearch}
          placeholder="Search candidates…"
          onChange={(e) => onCandidateSearch(e.target.value)}
        />
      </div>

      <div className="ia-filter-input">
        <label>Job Title</label>
        <input
          type="text"
          value={jobTitleSearch}
          placeholder="Search job titles…"
          onChange={(e) => onJobTitleSearch(e.target.value)}
        />
      </div>

      <div className="ia-status-chips">
        <label>Status</label>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {CHIP_META.map(({ key, label, cssClass }) => (
            <button
              key={key}
              type="button"
              className={`ia-chip ${cssClass}${statuses[key] ? '' : ' chip-off'}`}
              onClick={() => onToggleStatus(key)}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FilterRow;
